/* 🤖 this file was generated by svg-to-ts*/
export const iconActions: {
  name: 'actions';
  data: string;
} = {
  name: 'actions',
  data: `<svg width="12" height="16" xmlns="http://www.w3.org/2000/svg"><path d="M9 11.006c1.654 0 3-1.346 3-3v-5c0-1.654-1.346-3-3-3H3c-1.654 0-3 1.346-3 3v5c0 1.654 1.346 3 3 3a1 1 0 100-2c-.551 0-1-.448-1-1v-5c0-.552.449-1 1-1h6c.551 0 1 .448 1 1v5c0 .552-.449 1-1 1a1 1 0 100 2zm-3.346 4.93a.974.974 0 00.693 0c.035-.013.066-.03.099-.046.036-.019.075-.03.109-.052l3-2a1.001 1.001 0 00-1.11-1.664L7 13.137v-5.13a1 1 0 10-2 0v5.13l-1.445-.963a1 1 0 10-1.109 1.664l3 2c.034.022.072.033.109.052.033.016.063.033.099.046z" fill="currentColor" fill-rule="nonzero"/></svg>`,
};
